
export default {
  banner: [
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner01.png',
      url:'https://mp.weixin.qq.com/s/Ty6a4Cf2mzRHCNfOiKV4rw'
    },
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner02.png',
      url:'/customize'
    },
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner03.png',
      url:'https://mp.weixin.qq.com/s/tGqsDJDhpuIuxjm3jI2mdw'
    },
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner04.png',
      url:'https://mp.weixin.qq.com/s/W8rYdMx3QTifkYGuFu0V_g'
    },
  ],
  mbanner: [
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner01.png',
      url:'https://mp.weixin.qq.com/s/Ty6a4Cf2mzRHCNfOiKV4rw'
    },
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner02.png',
      url:'/CustomizeMobile'
    },
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner03.png',
      url:'https://mp.weixin.qq.com/s/tGqsDJDhpuIuxjm3jI2mdw'
    },
    {
      img:'https://qishimai-1257428522.file.myqcloud.com/website/banner/websitebanner04.png',
      url:'https://mp.weixin.qq.com/s/W8rYdMx3QTifkYGuFu0V_g'
    },
  ],
  about: {
    video: 'https://qishimai-1257428522.file.myqcloud.com/website/other/qishimaiinfo.mov',
    text: '北京七十迈国际旅行社, 创建于2013年。总部位于北京，并在上海、西安、乌鲁木齐、西宁、贵阳、昆明等地设有分公司/服务站点。截止 2021年，七十迈旅行的海外路线覆盖北美、澳新、欧洲、非洲、南美等70多个国家；国内路线200多条，遍布祖国大江南北。  和七十迈一起，像朋友一样去旅行。',
    url: ''
  },
  roadbook: {
    text: '我们是一群细致、靠谱的旅行定制师。智能路书，绝非堆砌，大街小巷，任你行走。',
    booklist: [
      {
        id: 1,
        name: '陕西沿黄公路自驾游7日游',
        subname: '延安 梁家河 雨岔大峡谷 波浪谷  乾坤湾',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook01.png',
        price: 69.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/64af841e-b989-4de7-8740-bb570d83d8ad.jpg',
        uuid: '8FEX4VXv',
      },
      {
        id: 2,
        name: '青海火星一号公路自驾游7日游',
        subname: 'U形天路 水上雅丹 火星营地 艾肯泉 翡翠湖 冷湖废弃石油基地',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook02.png',
        price: 69.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/d1322c6c-625e-4c89-84a5-369abc1e9389.jpg',
        uuid: 'L1nxGRPl',
      },
      {
        id: 3,
        name: '广东福建美食美景自驾游7日游',
        subname: '福建土楼 潮汕美食 客家文化 东山岛 鱼骨沙洲',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook03.png',
        price: 69.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/8206bc2f-d29f-4ebf-9c4f-18a300d5e4e8.jpg',
        uuid: 'sMvB8Vco',
      },
      {
        id: 4,
        name: '山海之歌涠洲岛7日游',
        subname: '吉星岩 鹅泉 德天跨国瀑布 明仕田园 北海银滩 涠洲岛',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook04.png',
        price: 69.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/f73f66e5-e2f1-45ba-8a17-7b62d1f25b06.jpg',
        uuid: '7OBdTtst',
      },
      {
        id: 5,
        name: '新疆独库公路7日游',
        subname: '独山子大峡谷 那拉提草原 巴音布鲁克 吐鲁番',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook05.png',
        price: 69.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/33d8901c-506c-4ffe-9e5e-7e7a2d604e26.jpg',
        uuid: '3WCd7Bns',
      },
      {
        id: 6,
        name: '甘青经典大环线12日游',
        subname: '天境祁连 皇家军马场 七彩丹霞 嘉峪关 敦煌莫高窟',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook07.png',
        price: 119.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/953e706c-6997-40b1-bd6c-4b8bce36c4eb.jpg',
        uuid: 'NSX0TWPr',
      },
      {
        id: 7,
        name: '黔西南深度自驾游9日',
        subname: '乌江源 织金洞 黄果树瀑布 万峰林 格凸河 中国天眼',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook06.png',
        price: 89.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/3508b9df-b8cd-4509-94b9-429bdd368379.jpg',
        uuid: 'psbFD8GY',
      },
      {
        id: 8,
        name: '云南四川横断山脉大环线自驾游14日游',
        subname: '丽江 香格里拉 梅里雪山 雨崩徒步 阳光河谷乡城 稻城亚丁 泸亚线穿越 泸沽湖',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook08.png',
        price: 139.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/831cccc8-52f0-463e-887b-ac3cc16c277e.jpg',
        uuid: 'aNc7rB8c',
      },
      {
        id: 9,
        name: '青海柴达木盆地穿越自驾游9日游',
        subname: '火星营地 俄博梁魔鬼城 东台吉乃尔湖 艾肯泉 U形公路 茶卡盐湖 青海湖',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook09.png',
        price: 89.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/516bd4c8-ddb9-4aa2-811e-e3b117a20d7a.jpg',
        uuid: '',
      },
      {
        id: 10,
        name: '梦回古都西安3游',
        subname: '兵马俑 大雁塔 钟楼 回民街 永兴坊',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook10.png',
        price: 29.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/a2573029-0995-48e7-88e8-de39d3b16f82.jpg',
        uuid: 'ZTj1Voka',
      },
      {
        id: 11,
        name: '福建武夷山一地慢节奏5日游',
        subname: '白云禅寺云海日出 九曲溪漂流 天游峰 疑无路 岩骨花香慢游道',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook11.png',
        price: 28.90,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/f9ddd813-8144-49e8-b562-7a50e8c9cb0a.jpg',
        uuid: 'hzA45yOI',
      },
      {
        id: 12,
        name: '云南东南部自驾游9日游',
        subname: '抚仙湖 建水古城 普者黑 蒙自 弥勒',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook12.png',
        price: 89.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/f71e4fe7-eb57-4d3a-8500-5ad234823b9e.jpg',
        uuid: '0dWm7YHH',
      },
      {
        id: 13,
        name: '北疆喀纳斯大环线9日游',
        subname: '喀纳斯 魔鬼城 禾木 白哈巴 可可托海',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook13.png',
        price: 89.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/a5a4eeee-bd0b-458b-9a17-6515616403c4.jpg',
        uuid: 'IBngopzn',
      },
      {
        id: 14,
        name: '贵州黔东南经典自驾游5日游',
        subname: '荔波小七孔 加榜梯田 岜沙苗寨 大利侗寨 千户苗寨 青岩古镇',
        image: 'https://qishimai-1257428522.file.myqcloud.com/website/book/websitebook14.png',
        price: 49.00,
        url: 'https://qishimai-1257428522.file.myqcloud.com/file/QRCode/08dbe68d-4a4a-43c1-858d-10042cd8c98b.jpg',
        uuid: 'oCSKU1A6',
      },
    ]
  },
  customize: {
    text: '我们是一群职业国际自驾游领队，也是深度旅行发烧友，2013年至今，足迹遍布全球70多个国家和地区。 欢迎关注我们，组队一起玩，或了解我们定期分享的纯干货旅行攻略、旅行故事。 产品：跟队自驾游路线、电子路书产品(口袋导游）'
  },
  grouptour: {
    text: '我们是一群爱玩、会玩的职业旅行家。跟队自驾，领队护航，驰骋干里，心有方向。',
    citys: [
      // {
      //   name: '东南地区',
      //   routelist: [
      //     // {
      //     //   id: 11,
      //     //   name: '寻味闽粤丨广东福建文化与美食跟团自驾游9日',
      //     //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021803.png',
      //     //   price: 7900,
      //     //   url: 'https://mp.weixin.qq.com/s/n7OHLkCs-A88V8kF__E0Jg'
      //     // },
      //     // {
      //     //   id: 12,
      //     //   name: '八闽大地丨福建一地美食美景跟团自驾游9日',
      //     //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021808.png',
      //     //   price: 10900,
      //     //   url: 'https://mp.weixin.qq.com/s/FLhOxgsZznVVcCclE6feeA'
      //     // },
      //     // {
      //     //   id: 61,
      //     //   name: '寻味闽粤丨广东福建文化与美食跟团自驾游9日',
      //     //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/001.jpg',
      //     //   price: 8100,
      //     //   url: 'https://mp.weixin.qq.com/s/b29_wuW9X_NzVl7krjopFg'
      //     // },
      //     // {
      //     //   id: 62,
      //     //   name: '八闽大地丨福建一地美食美景跟团自驾游9日',
      //     //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/002.jpg',
      //     //   price: 9500,
      //     //   url: 'https://mp.weixin.qq.com/s/Zaj-QIuiqd5rClbAkiOWmw'
      //     // }
      //   ]
      // },
      {
        name: '西北地区',
        routelist: [
          {
            id: 86,
            name: '穿越柴达木丨青海轻越野体验跟团自驾游9日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/006.jpg',
            price: 6500,
            url: 'https://mp.weixin.qq.com/s/XAd8yHNPx2elIgazxDBtKA'
          },
          {
            id: 87,
            name: '视觉盛宴丨甘肃青海大环线跟团自驾9日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/007.jpg',
            price: 7000,
            url: 'https://mp.weixin.qq.com/s/RsqN7d796PWGaPHkccfxwQ'
          },
          {
            id: 88,
            name: '视觉盛宴丨甘肃青海大环线跟团自驾12日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/008.jpg',
            price: 8400,
            url: 'https://mp.weixin.qq.com/s/VNF4dG15JO075qnmJ_M6Zw'
          },
          // {
          //   id: 1,
          //   name: '穿越柴达木丨青海轻越野体验跟团自驾游9日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute01.png',
          //   price: 7800,
          //   url: 'https://mp.weixin.qq.com/s/tGqsDJDhpuIuxjm3jI2mdw'
          // },
          // {
          //   id: 2,
          //   name: '视觉盛宴丨甘肃青海大环线跟团自驾12日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute02.png',
          //   price: 8600,
          //   url: 'https://mp.weixin.qq.com/s/et4PiyLh9BKtJ0GzaIlETQ'
          // },
          {
            id: 3,
            name: '中国一号公路丨陕西沿黄公路跟团自驾游9日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute03.png',
            price: 5800,
            url: 'https://mp.weixin.qq.com/s/wGQj_f-zHzAkM2qCW8obeA'
          },
          {
            id: 4,
            name: '七彩秘境丨甘南川北跟团自驾游9日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute04.png',
            price: 6400,
            url: 'https://mp.weixin.qq.com/s/GYW-RZVB1B1DsWecCy9Ocg'
          }
        ]
      },
      {
        name: '西南地区',
        routelist: [
          // {
          //   id: 13,
          //   name: '彩云之南丨滇南文化胜境跟团自驾游9日-冬季版',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021807.png',
          //   price: 8800,
          //   url: 'https://mp.weixin.qq.com/s/GpVUXdIVncPzkKeYdp-5WA'
          // },
          // {
          //   id: 14,
          //   name: '滇南文化胜境跟团自驾游9日-油菜花版',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021806.png',
          //   price: 8300,
          //   url: 'https://mp.weixin.qq.com/s/0zZxOvMkS-yMXRARnjBZCw'
          // },
          // {
          //   id: 15,
          //   name: '情迷喀斯特丨广西跟团自驾游9日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021804.png',
          //   price: 7900,
          //   url: 'https://mp.weixin.qq.com/s/-rIpflT2DT5Ihz1uw_cRfQ'
          // },
          // {
          //   id: 16,
          //   name: '黔山万水丨贵州黔西南跟团自驾游8日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021805.png',
          //   price: 8200,
          //   url: 'https://mp.weixin.qq.com/s/XBJg663dZSmtVL1fJAvglQ'
          // },
          {
            id: 65,
            name: '桃花源记丨贵州黔东南跟团自驾游9日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/004.jpg',
            price: 6500,
            url: 'https://mp.weixin.qq.com/s/Ws5YENdoXye-MX8NFXrdRg'
          },
          {
            id: 66,
            name: '彩云之南丨滇南文化胜境跟团自驾游9日-夏季版',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/005.jpg',
            price: 5400,
            url: 'https://mp.weixin.qq.com/s/Vzxl6kUU2vFiDJZP5uRCjw'
          }
        ]
      },
      {
        name: '新疆',
        routelist: [
          // {
          //   id: 5,
          //   name: '北疆之秋 | 新疆喀纳斯大环线跟团自驾游11日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute05.png',
          //   price: 9600,
          //   url: 'https://mp.weixin.qq.com/s/SUXA4N7B4o_8y1T91pae8g'
          // },
          {
            id: 6,
            name: '草原牧歌丨新疆环天山+独库公路跟团自驾游12日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute06.png',
            price: 8600,
            url: 'https://mp.weixin.qq.com/s/8fYKcETYdFc4Yie7yKYMUw'
          },
          {
            id: 7,
            name: '神之花园丨 新疆喀纳斯大环线跟团自驾游10日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute07.png',
            price: 7000,
            url: 'https://mp.weixin.qq.com/s/PLBJVZfTssyUeVodcpu7_Q'
          },
          {
            id: 8,
            name: '纵横新疆｜独库公路+塔克拉玛干沙漠公路+喀什跟团自驾游14日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute08.png',
            price: 9600,
            url: 'https://mp.weixin.qq.com/s/7u5lMRHYonHHsiFsxI0nzA'
          },
          // {
          //   id: 9,
          //   name: '西域天路丨南疆喀什小环线跟团自驾游7日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute09.png',
          //   price: 6500,
          //   url: 'https://mp.weixin.qq.com/s/Pus7I5LVzat_9fxFcgREdQ'
          // },
          {
            id: 10,
            name: '西域天路丨南疆喀什大环线跟团自驾游13日 ',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/websiteroute10.png',
            price: 9500,
            url: 'https://mp.weixin.qq.com/s/8eh6ij_zkoSXWk8nhU5dBg'
          },
          // {
          //   id: 91,
          //   name: '帕米尔之春丨南疆杏花季跟团自驾游7日',
          //   image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021801.png',
          //   price: 6700,
          //   url: 'https://mp.weixin.qq.com/s/LNoaxb4AtZ142WKh5yFmzw'
          // }
          {
            id: 92,
            name: '草原牧歌丨新疆伊宁环天山跟团自驾游8日',
            image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/009.jpg',
            price: 5300,
            url: 'https://mp.weixin.qq.com/s/3PW9Zv179LZ5BVb3VrijHA'
          }
        ]
      },
      // {
      //   name: '西藏',
      //   routelist: [
      //     {
      //       id: 90,
      //       name: '雪域桃源丨林芝桃花源跟团自驾游7日',
      //       image: 'https://qishimai-1257428522.file.myqcloud.com/website/route/new021802.png',
      //       price: 9900,
      //       url: 'https://mp.weixin.qq.com/s/uSPoj9tuUs0vK6IgWi4B0Q'
      //     }
      //   ]
      // },
    ]
  },
  evaluate: {
    text: '自2013年开始，七十迈已服务超过2万人，走过全球70多个国家和地区。在这里和万千旅行爱好者一起实现你的旅行梦想。',
    commentlist: [
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_1.png',
        username: '盐焗小星球',
        date: '2021年4月21日',
        content: '感谢七十迈的路书产品，让我们获得了一次无与伦比的海西自驾之行！七天的路书价格实惠，功能强大，直接通过小程序打开，每日路线，车程时间，美食和住宿推荐都安排的明明白白，还可以直接导航。特别是每个景点都有七十迈团队实地踩点后的提示和讲解，比一般网上攻略要更加详细真实。下次的旅行还会选择七十迈路书，绝对是自驾好伙伴！',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment1-1.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment1-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment1-2.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment1-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment1-3.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment1-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment1-4.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment1-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_2.png',
        username: '一颗草莓',
        date: '2021年5月21日',
        content: '整体行程接近完美，领队魏迎春专业，能很好的把控时间，让我们欣赏了更好的景致。希望能把路线进一步优化，前一天的石河子可以不去，最后两天有些不好，尤其是领队一路开车辛苦，还要担心43℃高温天气对汽车轮胎的影响。如果减去后两天行程，在库车结束，不返回乌鲁木齐，就会更加完美。希望七十迈越来越好！',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment2-1.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment2-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment2-2.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment2-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment2-3.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment2-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment2-4.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment2-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_3.png',
        username: 'Bi8bo',
        date: '2021年6月2日',
        content: '新疆太美了，令人流连忘返。行程增加一至两天，可能会效果更好。希望能多挖掘更多小众且有当地特色的景点。',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment3-1.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment3-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment3-2.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment3-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment3-3.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment3-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment3-4.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment3-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_4.png',
        username: '大派大星',
        date: '2021年7月1日',
        content: '新疆有多美，去了才知道。旅行的目的就是要自由自在地亲近自然，融入大自然的美景之中，品尝当地的美食。所以自驾旅行是最佳的选择。新疆的第一次旅行，我选择了七十迈的“新疆环天山+独库公路跟团自驾游”。12天的旅行囊括了独山子大峡谷、赛里木湖、夏塔古道国家森林公园、那拉提草原、巴音布鲁克。置身于峡谷、湖泊、草原、河流、雪山，以及美丽的薰衣草之中，真是令人陶醉。去新疆一定要走独库公路，沿途的林木郁郁葱葱，每走几米就有不同的景色。入住赛里木湖畔的房车营地，抬头就能看到美丽的湖光山色，迈一步就到湖水边也是行程中的一大亮点。此外，还有人体草原、空中草原、九曲十八弯落日都是必看的风景。整个旅程不仅是有预设好的重要风暴点，也会根据大家感兴趣的沿途风景随机停车拍照、留影、玩耍一阵子，这就是自驾游的优势，关键是领队能够热心并很职业的做到这一点。整个旅程紧凑、轻松而快乐，十二天的行程一晃就过去了，期待下一次旅行的开始。',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment4-1.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment4-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment4-2.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment4-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment4-3.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment4-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/banner/comment4-4.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment4-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_5.png',
        username: '望月纱',
        date: '2021年5月1日',
        content: '五一去延安，用了七十迈的路书，很方便，就像是有个领队带着你自驾一样。路书里不只有每天的计划，景点之间的距离和所需时间，还有每个景点的详细攻略和讲解，讲解还有音频的，方便开车的时候或者参观的时候边走边听。路书还会推荐吃饭的地方，不用自己在成百个餐厅里选了，太贴心了。',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment5-1.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment5-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment5-2.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment5-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment5-3.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment5-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment5-4.png',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment5-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_6.png',
        username: '宁静致远',
        date: '2021年6月20日',
        content: '一时兴起决定去新疆，没有约到同行小伙伴，也没有时间做攻略，怎么办？跟着七十迈玩就对了！路线选择丰富，行程安排灵活合理，天南海北的小伙伴就地成团，领队经验丰富，带你解锁各种隐藏玩法，全程专业拍摄设备美景锁定！新疆那么美，跟着七十迈去看看',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment6-1.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment6-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment6-2.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment6-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment6-3.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment6-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment6-4.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment6-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_7.png',
        username: '爱学习的三金金金',
        date: '2021年5月15日',
        content: '和你们一趟又一趟，变化的是行程，不变的是贴心的品质，像朋友一样去旅行，70迈，真实不虚！',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment7-1.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment7-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment7-2.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment7-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment7-3.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment7-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment7-4.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment7-4.png',
          }
        ]
      },
      {
        useravatar: 'https://qishimai-1257428522.file.myqcloud.com/website/other/avatar_8.png',
        username: 'Katrina',
        date: '2021年6月18日',
        content: '历史悠久的客家文化，潮汕美食，还有那灵山碧水，无不让人难忘。旅行社有很多，特别用心一见倾心的不多七十迈，就是这样，每一趟行程都会如此用心，每一个领队都是温暖贴心。感谢曹队，辛苦了！',
        images: [
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment8-1.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment8-1.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment8-2.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment8-2.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment8-3.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment8-3.png',
          },
          {
            bigImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/comment8-4.jpg',
            minImg: 'https://qishimai-1257428522.file.myqcloud.com/website/comment/mincomment8-4.png',
          }
        ]
      }
    ]
  },
  travelstory: {
    text: '现代旅行，已经告别了走马观花，开始了细致入微的求知。和七十迈一起，了解那些不为人知的故事。',
    storylist: [
      {
        id: 1,
        name: '在西安坐地铁，就像是穿梭在古墓群中',
        author: '芦伟',
        image: 'https://qishimai-1257428522.file.myqcloud.com/img/nom/328727d918ae47a0824db4594e74462c.jpg',
        audio: 'https://qishimai-1257428522.file.myqcloud.com/audio/3529e51ca06d449a9909596c90f0dc86.mp3',
      },
      {
        id: 2,
        name: '兰州和青海牛肉拉面的恩怨情仇',
        author: '辛未',
        image: 'https://qishimai-1257428522.file.myqcloud.com/img/nom/8c435191c07f46029982d9b2543ddb49.jpg',
        audio: 'https://qishimai-1257428522.file.myqcloud.com/audio/5632f73889dd495aaa0057c8ebb78bba.mp3',
      },
      {
        id: 3,
        name: '新疆的中国之最，你知道多少？',
        author: '杨露仪',
        image: 'https://qishimai-1257428522.file.myqcloud.com/img/nom/b21ad73db01f4bcea55bcbd3d9e9e66b.jpg',
        audio: 'https://qishimai-1257428522.file.myqcloud.com/audio/e85e8522608e4de5b535b0034f48d1fb.mp3',
      },
    ]
  }
}


// WEBPACK FOOTER //
// ./src/utils/staticData/homeData.js